<template>
  <div id="printableArea">
    <div class="container-fluid pt-4" dir="rtl">
      <div class="row">
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3"></div>
        <div class="col-md-3">
          <button class="bg-warning btn no-print mb-2 mr-2 text-light Pointer float-left" @click="$router.go(-1)">بازگشت</button>

          <button class="bg-success btn no-print mb-2 text-light Pointer float-left" @click="GetPrint()">چــاپ</button>
        </div>
      </div>
      <div v-if="$route.params.Status == 'Single'" class="print">
        <table class="table table-bordered border-dark">
          <thead>
            <tr>
              <td colspan="6" class="py-1">
                <div class="row mx-auto justify-content-between align-items-center">
                  <div class="col-auto px-0" style="width: 100px; max-width: 100px">
                    <div style="height: 100px"></div>
                  </div>
                  <div class="col-auto" style="font-size: 14px">{{ DataAxios.WorkShopName }}</div>
                  <div class="col-auto">فیش حقوقی {{ DataAxios.Month }} ماه {{ DataAxios.Year }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="6">
                <div class="row mx-auto justify-content-center">
                  <div class="col-auto">نام و نام خانوادگی: {{ DataAxios.NamFam }}</div>
                  <div class="col-auto">کد پرسنلی: {{ DataAxios.PersonnelCode }}</div>
                  <div class="col-auto">کد ملی: {{ DataAxios.NationalCode }}</div>
                </div>
              </td>
            </tr>
            <tr>
              <td style="background: #c6c7c7 !important" width="20%">اطلاعات پایه</td>
              <td style="background: #c6c7c7 !important" width="15%">کارکرد</td>
              <td style="background: #c6c7c7 !important" width="20%">حقوق و مزایا</td>
              <td style="background: #c6c7c7 !important" width="15%">مبلغ</td>
              <td style="background: #c6c7c7 !important" width="15%">کسورات</td>
              <td style="background: #c6c7c7 !important" width="15%">مبلغ</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <p v-if="DataAxios.Performance.WorkPerformanceDaily > 0">کارکرد روزانه</p>
                <p v-if="DataAxios.Performance.AddWorkPerformanceHour > 0 || DataAxios.Performance.AddWorkPerformanceMinutes > 0">کارکرد اضافه کاری</p>
                <p v-if="DataAxios.Performance.MissionPerformanceDaily > 0">کارکرد ماموریت روزانه</p>
                <p v-if="DataAxios.Performance.AbsentPerformanceDaily > 0">غیبت</p>
                <p v-if="DataAxios.Performance.FoodPerformanceDaily > 0">روز حق غذا</p>
                <p v-if="DataAxios.Performance.VacationPerformanceDay > 0 || DataAxios.Performance.VacationPerformanceHour > 0 || DataAxios.Performance.VacationPerformanceMinutes > 0">مرخصی استحقاقی</p>
                <p v-if="DataAxios.Performance.SickPerformanceDay > 0">مرخصی استعلاجی</p>
                <p v-if="DataAxios.Performance.NoSalaryVacationPerformance > 0">مرخصی بی حقوق</p>
                <p v-if="DataAxios.Performance.MissPerformanceHourse > 0 || DataAxios.Performance.MissPerformanceMinutes > 0">کسری کار</p>
              </td>
              <td>
                <p v-if="DataAxios.Performance.WorkPerformanceDaily > 0">{{ DataAxios.Performance.WorkPerformanceDaily }} روز</p>
                <p v-if="DataAxios.Performance.AddWorkPerformanceHour > 0 || DataAxios.Performance.AddWorkPerformanceMinutes > 0">{{ DataAxios.Performance.AddWorkPerformanceHour }} ساعت - {{ DataAxios.Performance.AddWorkPerformanceMinutes }} دقیقه</p>
                <p v-if="DataAxios.Performance.MissionPerformanceDaily > 0">{{ DataAxios.Performance.MissionPerformanceDaily }} روز</p>
                <p v-if="DataAxios.Performance.AbsentPerformanceDaily > 0">{{ DataAxios.Performance.AbsentPerformanceDaily }} روز</p>
                <p v-if="DataAxios.Performance.FoodPerformanceDaily > 0">{{ DataAxios.Performance.FoodPerformanceDaily }} روز</p>
                <p v-if="DataAxios.Performance.VacationPerformanceDay > 0 || DataAxios.Performance.VacationPerformanceHour > 0 || DataAxios.Performance.VacationPerformanceMinutes > 0">
                  {{ DataAxios.Performance.VacationPerformanceDay }} روز - {{ DataAxios.Performance.VacationPerformanceHour }} ساعت - {{ DataAxios.Performance.VacationPerformanceMinutes }} دقیقه
                </p>
                <p v-if="DataAxios.Performance.SickPerformanceDay > 0">{{ DataAxios.Performance.SickPerformanceDay }} روز</p>
                <p v-if="DataAxios.Performance.NoSalaryVacationPerformance > 0">{{ DataAxios.Performance.NoSalaryVacationPerformance }} روز</p>
                <p v-if="DataAxios.Performance.MissPerformanceHourse > 0 || DataAxios.Performance.MissPerformanceMinutes > 0">{{ DataAxios.Performance.MissPerformanceHourse }} ساعت - {{ DataAxios.Performance.MissPerformanceMinutes }} دقیقه</p>
              </td>
              <td>
                <p v-if="DataAxios.SalaryAndBenefits.SalaryBasic > 0">حقوق پایه</p>
                <p v-if="DataAxios.SalaryAndBenefits.Home > 0">حق مسکن</p>
                <p v-if="DataAxios.SalaryAndBenefits.Bone > 0">حق بن</p>
                <p v-if="DataAxios.SalaryAndBenefits.AddWork > 0">اضافه کاری</p>
                <p v-if="DataAxios.SalaryAndBenefits.Misson > 0">ماموریت</p>
                <p v-if="DataAxios.SalaryAndBenefits.Sanavat > 0">پایه سنوات</p>
                <p v-if="DataAxios.SalaryAndBenefits.Child > 0">حق اولاد</p>
                <p v-if="DataAxios.SalaryAndBenefits.Skill > 0">مهارت</p>
                <p v-if="DataAxios.SalaryAndBenefits.Education > 0">حق تحصیلات</p>
                <p v-if="DataAxios.SalaryAndBenefits.Amazing > 0">فوق العاده</p>
                <p v-if="DataAxios.SalaryAndBenefits.Rewards > 0">پاداش</p>
                <p v-if="DataAxios.SalaryAndBenefits.HageJazb > 0">حق جذب</p>
                <p v-if="DataAxios.SalaryAndBenefits.HageShift > 0">حق شیفت</p>
                <p v-if="DataAxios.SalaryAndBenefits.HardWork > 0">سختی کار</p>
                <p v-if="DataAxios.SalaryAndBenefits.Food > 0">حق غذا</p>
                <p v-if="DataAxios.SalaryAndBenefits.Cashier > 0">صندوقدار</p>
                <p v-if="DataAxios.SalaryAndBenefits.Transportation > 0">ایاب و ذهاب</p>
                <p v-if="DataAxios.SalaryAndBenefits.Eidi > 0">عیدی</p>
                <p v-if="DataAxios.SalaryAndBenefits.OtherBenefits > 0">سایر مزایا</p>
                <p v-if="DataAxios.SalaryAndBenefits.YearSanavat > 0">سنوات پایان سال</p>
                <p v-if="DataAxios.SalaryAndBenefits.Responsibility > 0">حق مسئولیت</p>
              </td>
              <td>
                <p v-if="DataAxios.SalaryAndBenefits.SalaryBasic > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.SalaryBasic) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Home > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Home) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Bone > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Bone) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.AddWork > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.AddWork) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Misson > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Misson) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Sanavat > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Sanavat) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Child > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Child) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Skill > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Skill) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Education > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Education) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Amazing > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Amazing) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Rewards > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Rewards) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.HageJazb > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.HageJazb) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.HageShift > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.HageShift) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.HardWork > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.HardWork) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Food > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Food) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Cashier > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Cashier) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Transportation > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Transportation) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Eidi > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Eidi) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.OtherBenefits > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.OtherBenefits) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.YearSanavat > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.YearSanavat) }}</p>
                <p v-if="DataAxios.SalaryAndBenefits.Responsibility > 0">{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Responsibility) }}</p>
              </td>
              <td>
                <p v-if="DataAxios.Deductions.Bime > 0">بیمه</p>
                <p v-if="DataAxios.Deductions.BimeTakmily > 0">بیمه تکمیلی</p>
                <p v-if="DataAxios.Deductions.Sos > 0">مساعده</p>
                <p v-if="DataAxios.Deductions.Facility > 0">تسهیلات</p>
                <p v-if="DataAxios.Deductions.Tax > 0">مالیات</p>
                <p v-if="DataAxios.Deductions.MissOther > 0">سایر کسورات</p>
                <p v-if="DataAxios.Deductions.MissPerformance > 0">کسری کار</p>
              </td>
              <td>
                <p v-if="DataAxios.Deductions.Bime > 0">{{ $Comma3ragham(DataAxios.Deductions.Bime) }}</p>
                <p v-if="DataAxios.Deductions.BimeTakmily > 0">{{ $Comma3ragham(DataAxios.Deductions.BimeTakmily) }}</p>
                <p v-if="DataAxios.Deductions.Sos > 0">{{ $Comma3ragham(DataAxios.Deductions.Sos) }}</p>
                <p v-if="DataAxios.Deductions.Facility > 0">{{ $Comma3ragham(DataAxios.Deductions.Facility) }}</p>
                <p v-if="DataAxios.Deductions.Tax > 0">{{ $Comma3ragham(DataAxios.Deductions.Tax) }}</p>
                <p v-if="DataAxios.Deductions.MissOther > 0">{{ $Comma3ragham(DataAxios.Deductions.MissOther) }}</p>
                <p v-if="DataAxios.Deductions.MissPerformance > 0">{{ $Comma3ragham(DataAxios.Deductions.MissPerformance) }}</p>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td colspan="3" style="background: #c6c7c7 !important">جمع پرداختی</td>
              <td>{{ $Comma3ragham(DataAxios.SalaryAndBenefits.Sum) }}</td>
              <td style="background: #c6c7c7 !important">جمع کسورات</td>
              <td>{{ $Comma3ragham(DataAxios.Deductions.Sum) }}</td>
            </tr>
            <tr>
              <td colspan="5" style="background: #c6c7c7 !important">
                خالص پرداختی به حروف <span class="h5">[ {{ Mab2persian(Number(DataAxios.SalaryAndBenefits.Sum) - Number(DataAxios.Deductions.Sum)) }} ]</span>
              </td>
              <td style="font-weight: bold">
                {{ $Comma3ragham(Number(DataAxios.SalaryAndBenefits.Sum) - Number(DataAxios.Deductions.Sum)) }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-else id="print">
        <div v-for="(item, index) in DataAxiosList" :key="index">
          <table class="table table-bordered border-dark">
            <thead>
              <tr>
                <td colspan="6" class="py-1">
                  <div class="row mx-auto justify-content-between align-items-center">
                    <div class="col-auto px-0" style="width: 100px; max-width: 100px">
                      <div style="height: 100px"></div>
                    </div>
                    <div class="col-auto" style="font-size: 14px">{{ item.WorkShopName }}</div>
                    <div class="col-auto">فیش حقوقی {{ item.Month }} ماه {{ item.Year }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="6">
                  <div class="row mx-auto justify-content-center">
                    <div class="col-auto">نام و نام خانوادگی: {{ item.NamFam }}</div>
                    <div class="col-auto">کد پرسنلی: {{ item.PersonnelCode }}</div>
                    <div class="col-auto">کد ملی: {{ item.NationalCode }}</div>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="background: #c6c7c7 !important" width="20%">اطلاعات پایه</td>
                <td style="background: #c6c7c7 !important" width="15%">کارکرد</td>
                <td style="background: #c6c7c7 !important" width="20%">حقوق و مزایا</td>
                <td style="background: #c6c7c7 !important" width="15%">مبلغ</td>
                <td style="background: #c6c7c7 !important" width="15%">کسورات</td>
                <td style="background: #c6c7c7 !important" width="15%">مبلغ</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p v-if="item.Performance.WorkPerformanceDaily > 0">کارکرد روزانه</p>
                  <p v-if="item.Performance.AddWorkPerformanceHour > 0 || item.Performance.AddWorkPerformanceMinutes > 0">کارکرد اضافه کاری</p>
                  <p v-if="item.Performance.MissionPerformanceDaily > 0">کارکرد ماموریت روزانه</p>
                  <p v-if="item.Performance.AbsentPerformanceDaily > 0">غیبت</p>
                  <p v-if="item.Performance.FoodPerformanceDaily > 0">روز حق غذا</p>
                  <p v-if="item.Performance.VacationPerformanceDay > 0 || item.Performance.VacationPerformanceHour > 0 || item.Performance.VacationPerformanceMinutes > 0">مرخصی استحقاقی</p>
                  <p v-if="item.Performance.SickPerformanceDay > 0">مرخصی استعلاجی</p>
                  <p v-if="item.Performance.NoSalaryVacationPerformance > 0">مرخصی بی حقوق</p>
                  <p v-if="item.Performance.MissPerformanceHourse > 0 || item.Performance.MissPerformanceMinutes > 0">کسری کار</p>
                </td>
                <td>
                  <p v-if="item.Performance.WorkPerformanceDaily > 0">{{ item.Performance.WorkPerformanceDaily }} روز</p>
                  <p v-if="item.Performance.AddWorkPerformanceHour > 0 || item.Performance.AddWorkPerformanceMinutes > 0">{{ item.Performance.AddWorkPerformanceHour }} ساعت - {{ item.Performance.AddWorkPerformanceMinutes }} دقیقه</p>
                  <p v-if="item.Performance.MissionPerformanceDaily > 0">{{ item.Performance.MissionPerformanceDaily }} روز</p>
                  <p v-if="item.Performance.AbsentPerformanceDaily > 0">{{ item.Performance.AbsentPerformanceDaily }} روز</p>
                  <p v-if="item.Performance.FoodPerformanceDaily > 0">{{ item.Performance.FoodPerformanceDaily }} روز</p>
                  <p v-if="item.Performance.VacationPerformanceDay > 0 || item.Performance.VacationPerformanceHour > 0 || item.Performance.VacationPerformanceMinutes > 0">
                    {{ item.Performance.VacationPerformanceDay }} روز - {{ item.Performance.VacationPerformanceHour }} ساعت - {{ item.Performance.VacationPerformanceMinutes }} دقیقه
                  </p>
                  <p v-if="item.Performance.SickPerformanceDay > 0">{{ item.Performance.SickPerformanceDay }} روز</p>
                  <p v-if="item.Performance.NoSalaryVacationPerformance > 0">{{ item.Performance.NoSalaryVacationPerformance }} روز</p>
                  <p v-if="item.Performance.MissPerformanceHourse > 0 || item.Performance.MissPerformanceMinutes > 0">{{ item.Performance.MissPerformanceHourse }} ساعت - {{ item.Performance.MissPerformanceMinutes }} دقیقه</p>
                </td>
                <td>
                  <p v-if="item.SalaryAndBenefits.SalaryBasic > 0">حقوق پایه</p>
                  <p v-if="item.SalaryAndBenefits.Home > 0">حق مسکن</p>
                  <p v-if="item.SalaryAndBenefits.Bone > 0">حق بن</p>
                  <p v-if="item.SalaryAndBenefits.AddWork > 0">اضافه کاری</p>
                  <p v-if="item.SalaryAndBenefits.Misson > 0">ماموریت</p>
                  <p v-if="item.SalaryAndBenefits.Sanavat > 0">پایه سنوات</p>
                  <p v-if="item.SalaryAndBenefits.Child > 0">حق اولاد</p>
                  <p v-if="item.SalaryAndBenefits.Skill > 0">مهارت</p>
                  <p v-if="item.SalaryAndBenefits.Education > 0">حق تحصیلات</p>
                  <p v-if="item.SalaryAndBenefits.Amazing > 0">فوق العاده</p>
                  <p v-if="item.SalaryAndBenefits.Rewards > 0">پاداش</p>
                  <p v-if="item.SalaryAndBenefits.HageJazb > 0">حق جذب</p>
                  <p v-if="item.SalaryAndBenefits.HageShift > 0">حق شیفت</p>
                  <p v-if="item.SalaryAndBenefits.HardWork > 0">سختی کار</p>
                  <p v-if="item.SalaryAndBenefits.Food > 0">حق غذا</p>
                  <p v-if="item.SalaryAndBenefits.Cashier > 0">صندوقدار</p>
                  <p v-if="item.SalaryAndBenefits.Trpansportation > 0">ایاب و ذهاب</p>
                  <p v-if="item.SalaryAndBenefits.Eidi > 0">عیدی</p>
                  <p v-if="item.SalaryAndBenefits.OtherBenefits > 0">سایر مزایا</p>
                  <p v-if="item.SalaryAndBenefits.YearSanavat > 0">سنوات پایان سال</p>
                  <p v-if="item.SalaryAndBenefits.Responsibility > 0">حق مسئولیت</p>
                </td>
                <td>
                  <p v-if="item.SalaryAndBenefits.SalaryBasic > 0">{{ $Comma3ragham(item.SalaryAndBenefits.SalaryBasic) }}</p>
                  <p v-if="item.SalaryAndBenefits.Home > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Home) }}</p>
                  <p v-if="item.SalaryAndBenefits.Bone > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Bone) }}</p>
                  <p v-if="item.SalaryAndBenefits.AddWork > 0">{{ $Comma3ragham(item.SalaryAndBenefits.AddWork) }}</p>
                  <p v-if="item.SalaryAndBenefits.Misson > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Misson) }}</p>
                  <p v-if="item.SalaryAndBenefits.Sanavat > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Sanavat) }}</p>
                  <p v-if="item.SalaryAndBenefits.Child > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Child) }}</p>
                  <p v-if="item.SalaryAndBenefits.Skill > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Skill) }}</p>
                  <p v-if="item.SalaryAndBenefits.Education > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Education) }}</p>
                  <p v-if="item.SalaryAndBenefits.Amazing > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Amazing) }}</p>
                  <p v-if="item.SalaryAndBenefits.Rewards > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Rewards) }}</p>
                  <p v-if="item.SalaryAndBenefits.HageJazb > 0">{{ $Comma3ragham(item.SalaryAndBenefits.HageJazb) }}</p>
                  <p v-if="item.SalaryAndBenefits.HageShift > 0">{{ $Comma3ragham(item.SalaryAndBenefits.HageShift) }}</p>
                  <p v-if="item.SalaryAndBenefits.HardWork > 0">{{ $Comma3ragham(item.SalaryAndBenefits.HardWork) }}</p>
                  <p v-if="item.SalaryAndBenefits.Food > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Food) }}</p>
                  <p v-if="item.SalaryAndBenefits.Cashier > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Cashier) }}</p>
                  <p v-if="item.SalaryAndBenefits.Trpansportation > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Trpansportation) }}</p>
                  <p v-if="item.SalaryAndBenefits.Eidi > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Eidi) }}</p>
                  <p v-if="item.SalaryAndBenefits.OtherBenefits > 0">{{ $Comma3ragham(item.SalaryAndBenefits.OtherBenefits) }}</p>
                  <p v-if="item.SalaryAndBenefits.YearSanavat > 0">{{ $Comma3ragham(item.SalaryAndBenefits.YearSanavat) }}</p>
                  <p v-if="item.SalaryAndBenefits.Responsibility > 0">{{ $Comma3ragham(item.SalaryAndBenefits.Responsibility) }}</p>
                </td>
                <td>
                  <p v-if="item.Deductions.Bime > 0">بیمه</p>
                  <p v-if="item.Deductions.BimeTakmily > 0">بیمه تکمیلی</p>
                  <p v-if="item.Deductions.Sos > 0">مساعده</p>
                  <p v-if="item.Deductions.Facility > 0">تسهیلات</p>
                  <p v-if="item.Deductions.Tax > 0">مالیات</p>
                  <p v-if="item.Deductions.MissOther > 0">سایر کسورات</p>
                  <p v-if="item.Deductions.MissPerformance > 0">کسری کار</p>
                </td>
                <td>
                  <p v-if="item.Deductions.Bime > 0">{{ $Comma3ragham(item.Deductions.Bime) }}</p>
                  <p v-if="item.Deductions.BimeTakmily > 0">{{ $Comma3ragham(item.Deductions.BimeTakmily) }}</p>
                  <p v-if="item.Deductions.Sos > 0">{{ $Comma3ragham(item.Deductions.Sos) }}</p>
                  <p v-if="item.Deductions.Facility > 0">{{ $Comma3ragham(item.Deductions.Facility) }}</p>
                  <p v-if="item.Deductions.Tax > 0">{{ $Comma3ragham(item.Deductions.Tax) }}</p>
                  <p v-if="item.Deductions.MissOther > 0">{{ $Comma3ragham(item.Deductions.MissOther) }}</p>
                  <p v-if="item.Deductions.MissPerformance > 0">{{ $Comma3ragham(item.Deductions.MissPerformance) }}</p>
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="3" style="background: #c6c7c7 !important">جمع پرداختی</td>
                <td>{{ $Comma3ragham(item.SalaryAndBenefits.Sum) }}</td>
                <td style="background: #c6c7c7 !important">جمع کسورات</td>
                <td>{{ $Comma3ragham(item.Deductions.Sum) }}</td>
              </tr>
              <tr>
                <td colspan="5" style="background: #c6c7c7 !important">
                  خالص پرداختی به حروف <span class="h6">[ {{ Mab2persian(Number(item.SalaryAndBenefits.Sum) - Number(item.Deductions.Sum)) }} ]</span>
                </td>
                <td style="font-weight: bold">
                  {{ $Comma3ragham(Number(item.SalaryAndBenefits.Sum) - Number(item.Deductions.Sum)) }}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Num2persian from 'num2persian'

export default {
  data() {
    return {
      DataAxios: {},
      DataAxiosList: [],
    }
  },
  components: {},

  beforeMount() {
    if (this.$route.params.Status == 'Single') {
      this.DataAxios = this.$route.params.DataRow
    } else {
      this.DataAxiosList = this.$route.params.DataRow
    }
  },
  methods: {
    Mab2persian(mab) {
      return Num2persian(mab) + ' ریال '
    },
    GetPrint() {
      var mywindow = window.open('', 'PRINT')

      mywindow.document.write('<html><head>')
      mywindow.document.write('<link rel="stylesheet" href="/assets/bootstrap/bootstrap.min.css"  >')
      mywindow.document.write('<link rel="stylesheet" href="/assets/iransans/font-face-Sans.css">')
      mywindow.document.write('<link rel="stylesheet" href="/assets/print/FishPrint.css">')
      mywindow.document.write('</head><body onload="window.print()" dir="rtl">')
      mywindow.document.write(document.getElementById('printableArea').innerHTML)
      mywindow.document.write('</body></html>')
      mywindow.document.close()
      mywindow.focus()
      mywindow.document.close()
    },
  },
}
</script>

<style scoped>
@media print {
  .no-print {
    display: none;
  }
}

* {
  font-weight: 900;
}

tr {
  color: var(--sidebar-color-item) !important;
}

table {
  background: var(--sidebar-bg-color) !important;
  color: var(--sidebar-color-item);
}

td {
  border-color: var(--table-border-color) !important;
}

th {
  font-weight: 900;
  text-align: center;
  color: var(--sidebar-color-item) !important;
  border-color: var(--table-border-color) !important;
}

thead {
  border-color: var(--table-border-color) !important;
}

tr:hover {
  color: var(--sidebar-color-item) !important;
  background: var(--sidebar-bg-color) !important;
}
</style>
